export default __webpack_public_path__ + "static/media/UsingMeasure.348878de.mp4";